import { render, staticRenderFns } from "./AequitexFeeList.vue?vue&type=template&id=6aa22aee&scoped=true&"
import script from "./AequitexFeeList.vue?vue&type=script&lang=js&"
export * from "./AequitexFeeList.vue?vue&type=script&lang=js&"
import style0 from "./AequitexFeeList.vue?vue&type=style&index=0&id=6aa22aee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa22aee",
  null
  
)

export default component.exports